export default __webpack_public_path__ + "static/media/icon_avatar.07a5e4bd.png";